import { motion } from "framer-motion";
import {
    ArrowRight,
    MessageCircle,
    Heart,
    Eye
} from "lucide-react";

export default function CommunityHighlights({

    community,

    highlights = [],

    onOpenThread,

}) {

    return (

        <section className="mt-20">

            {/* Header */}

            <div className="flex items-center justify-between mb-8">

                <div>

                    <h2 className="text-3xl font-bold text-gray-900">

                        Trending Discussions

                    </h2>

                    <p className="text-gray-500 mt-2">

                        Discover what people are talking about inside{" "}
                        <span className="font-semibold">
                            {community.title}
                        </span>

                    </p>

                </div>

                <button
                    className="
                        hidden
                        md:flex
                        items-center
                        gap-2
                        font-semibold
                        text-blue-600
                        hover:text-blue-700
                    "
                >

                    View All

                    <ArrowRight size={18}/>

                </button>

            </div>

            <div
                className="
                    grid
                    lg:grid-cols-3
                    md:grid-cols-2
                    gap-8
                "
            >

                {highlights.map((thread, index) => (

                    <motion.div

                        key={thread.id}

                        initial={{
                            opacity:0,
                            y:30
                        }}

                        whileInView={{
                            opacity:1,
                            y:0
                        }}

                        transition={{
                            delay:index*.08
                        }}

                        viewport={{
                            once:true
                        }}

                        whileHover={{
                            y:-6
                        }}

                        onClick={() =>
                            onOpenThread(thread)
                        }

                        className="
                            cursor-pointer
                            rounded-[30px]
                            bg-white/60
                            backdrop-blur-xl
                            border
                            border-white/30
                            shadow-lg
                            overflow-hidden
                            transition
                        "

                    >

                        {/* IMAGE */}

                        <div className="relative h-52">

                            <img

                                src={thread.image}

                                alt={thread.title}

                                className="
                                    w-full
                                    h-full
                                    object-cover
                                "

                            />

                            <div
                                className={`
                                    absolute
                                    inset-0
                                    bg-gradient-to-t
                                    ${community.gradient}
                                    opacity-25
                                `}
                            />

                        </div>

                        {/* BODY */}

                        <div className="p-6">

                            <div
                                className={`
                                    inline-flex
                                    px-3
                                    py-1
                                    rounded-full
                                    text-xs
                                    font-semibold
                                    ${community.badge}
                                `}
                            >

                                Trending

                            </div>

                            <h3
                                className="
                                    mt-4
                                    text-xl
                                    font-bold
                                    text-gray-900
                                    line-clamp-2
                                "
                            >

                                {thread.title}

                            </h3>

                            <p
                                className="
                                    mt-3
                                    text-gray-500
                                    line-clamp-3
                                    leading-7
                                "
                            >

                                {thread.description}

                            </p>

                            {/* Footer */}

                            <div
                                className="
                                    mt-6
                                    flex
                                    justify-between
                                    items-center
                                    text-gray-500
                                    text-sm
                                "
                            >

                                <div
                                    className="
                                        flex
                                        items-center
                                        gap-4
                                    "
                                >

                                    <StatIcon
                                        icon={<Heart size={16}/>}
                                        value={thread.likes}
                                    />

                                    <StatIcon
                                        icon={<MessageCircle size={16}/>}
                                        value={thread.comments}
                                    />

                                    <StatIcon
                                        icon={<Eye size={16}/>}
                                        value={thread.views}
                                    />

                                </div>

                                <ArrowRight
                                    className="
                                        text-gray-400
                                    "
                                    size={18}
                                />

                            </div>

                        </div>

                    </motion.div>

                ))}

            </div>

        </section>

    );

}

function StatIcon({

    icon,

    value,

}){

    return(

        <div
            className="
                flex
                items-center
                gap-1
            "
        >

            {icon}

            <span>

                {value}

            </span>

        </div>

    );

}